<template lang="pug">
div(v-if="this.vendor !== null")
  UiCardSection
    UiStack
      UiStackItem
        UiButton(
          variant="smooth-primary"
          @click="close()"
          icon="ArrowLeft"
        ) Back
      UiStackItem
        UiCard(
          shadow="never"
          border="always"
        )
          UiCardSection
            strong Name: {{ this.vendor.name }}

  UiCardSection
    UiTabs(
      :tabs="tabs"
      :selected="activeTab"
      @select="activeTab = $event"
      skin="light"
    )
  UiCardSection
    VendorTab(
      v-if="activeTab === 'vendor'"
      :vendor="vendor"
    )
    PurchaseInvoicesTab(
      v-if="activeTab === 'purchase_invoices'"
      :vendor_id="vendor.id"
    )
    ApproversTab(
      v-if="activeTab === 'approvers'"
      :target="'vendor'"
      :target_id="vendor.id"
    )
</template>

<script>
import ApiCompanyVendors from "@/api/companyVendors.js";
import VendorTab from "@/views/Vendor/tabs/vendor_tab.vue";
import PurchaseInvoicesTab from "@/views/Vendor/tabs/purchase_invoices.vue";
import ApproversTab from "@/views/Approvers/index.vue";

export default {
  components: {
    VendorTab,
    PurchaseInvoicesTab,
    ApproversTab,
  },

  props: ["id"],

  data() {
    return {
      activeTab: "vendor",
      vendor: null,
    };
  },

  computed: {
    tabs() {
      return [
        {
          id: "vendor",
          label: "Vendor",
        },
        {
          id: "purchase_invoices",
          label: "Purchase Invoices",
        },
        {
          id: "approvers",
          label: "Approvers",
        },
      ].filter((item) => item.visible ?? true);
    },
  },

  methods: {
    close() {
      const { vendor_id, invoice_id, ...rest } = this.$route.query;

      this.$router.push({ ...this.$route, query: rest });
    },

    fetchVendor() {
      ApiCompanyVendors.showVendor(this.$route.params.id, this.id).then(
        (resp) => {
          this.vendor = resp.data.vendor;
        },
      );
    },
  },

  watch: {
    id: {
      immediate: true,
      handler(_v, _ov) {
        this.fetchVendor();
      },
    },
  },
};
</script>
